<template>
    <div class="carousel slide carousel-fade">
        <div class="carousel-inner">
            <div v-for="(image, index) in images" :key="image.id" :class="['carousel-item', (index === 0 ? 'active': '')]" >
                <img v-if="image.url === undefined" src="https://via.placeholder.com/230x150/" class="d-block w-100 carouselImg">
                <img v-else :src="image.url" class="img-fluid d-block w-100 carouselImg">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FullPageCarousel',
    props: {
        images: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    mounted() {
        $('.carousel').carousel({
            interval: 5000,
            keyboard: false,
            pause: false,
            ride: 'carousel',
            
            // cycle: false
        })
    }
}
</script>

<style lang="scss" scoped>
    .carousel {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
    .carousel-inner {
        display: block;
        height: 100%;
        width: auto;
        // height: 100% !important;
        // width: auto;
    }

    .carousel-item {
        height: 100%;
        // height: 100%;
        // object-fit: cover;
    }

    .carouselImg {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }


    // Since we are using an old version of bootstrap we need to implement the fade ourselves
    .carousel-fade .carousel-item {
        opacity: 0;
        transition-duration: .6s;
        transition-property: opacity;
    }

    .carousel-fade  .carousel-item.active,
    .carousel-fade  .carousel-item-next.carousel-item-left,
    .carousel-fade  .carousel-item-prev.carousel-item-right {
        opacity: 1;
    }

    .carousel-fade .active.carousel-item-left,
    .carousel-fade  .active.carousel-item-right {
        opacity: 0;
    }

    .carousel-fade  .carousel-item-next,
    .carousel-fade .carousel-item-prev,
    .carousel-fade .carousel-item.active,
    .carousel-fade .active.carousel-item-left,
    .carousel-fade  .active.carousel-item-prev {
        transform: translateX(0);
        transform: translate3d(0, 0, 0);
    }
</style>